<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:36:06
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\noApproval\no-approval.vue
-->
<template>
  <div ref="NoApproval" class="noapproval">
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/no-approval11275.png"
      :alt="this.title"
    />
   <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NoApproval",
  props: {
    type: { type: String, default: null },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "暂无审批"
    }
  }
};
</script>
<style lang="scss" scoped>
.noapproval {
  text-align: center;
  .icon-img {
    height: 82px;
    width: 120px;
  }
}
</style>
